//Currency Symbol Using In All Services Pages
export const currencySymbols = {
    AED: 'د.إ',
    AFN: '؋',
    ALL: 'Lek',
    AMD: '֏',
    ANG: 'ƒ',
    AOA: 'Kz',
    ARS: '$',
    AUD: '$',
    AWG: 'ƒ',
    AZN: '₼',
    BAM: 'KM',
    BBD: '$',
    BDT: '৳',
    BGN: 'лв',
    BHD: '.د.ب',
    BIF: 'FBu',
    BMD: '$',
    BND: '$',
    BOB: 'Bs.',
    BRL: 'R$',
    BSD: '$',
    BTN: 'Nu.',
    BWP: 'P',
    // BYN: 'Br',
    BZD: '$',
    CAD: '$',
    CDF: 'FC',
    CHF: 'Fr',
    CLF: 'UF',
    CLP: '$',
    CNH: '¥',
    CNY: '¥',
    COP: '$',
    // CRC: '₡',
    // CUC: '$',
    CUP: '$',
    CVE: '$',
    CZK: 'Kč',
    DJF: 'Fdj',
    DKK: 'kr',
    DOP: '$',
    DZD: 'د.ج',
    EGP: 'ج.م',
    ERN: 'Nfk',
    ETB: 'Br',
    EUR: '€',
    FJD: '$',
    FKP: '£',
    GBP: '£',
    GEL: '₾',
    GHS: '₵',
    GIP: '£',
    GMD: 'D',
    GNF: 'FG',
    GTQ: 'Q',
    GYD: '$',
    HKD: '$',
    HNL: 'L',
    HRK: 'kn',
    HTG: 'G',
    HUF: 'Ft',
    IDR: 'Rp',
    ILS: '₪',
    INR: '₹',
    IQD: 'ع.د',
    IRR: '﷼',
    ISK: 'kr',
    JMD: '$',
    JOD: 'د.ا',
    JPY: '¥',
    KES: 'KSh',
    KGS: 'сом',
    KHR: '៛',
    KMF: 'CF',
    KPW: '₩',
    KRW: '₩',
    KWD: 'د.ك',
    KYD: '$',
    KZT: '₸',
    LAK: '₭',
    LBP: 'ل.ل',
    LKR: 'රු',
    LRD: '$',
    LSL: 'L',
    LYD: 'ل.د',
    MAD: 'د.م.',
    MDL: 'L',
    MGA: 'Ar',
    MKD: 'ден',
    MMK: 'K',
    MNT: '₮',
    MOP: 'MOP$',
    MRU: 'UM',
    MUR: '₨',
    MVR: 'ރ.',
    MWK: 'MK',
    MXN: '$',
    MYR: 'RM',
    MZN: 'MT',
    NAD: '$',
    NGN: '₦',
    // NIO: 'C$',
    NOK: 'kr',
    NPR: '₨',
    NZD: '$',
    OMR: 'ر.ع.',
    PAB: 'B/.',
    PEN: 'S/',
    PGK: 'K',
    PHP: '₱',
    PKR: '₨',
    PLN: 'zł',
    PYG: '₲',
    QAR: 'ر.ق',
    RON: 'lei',
    RSD: 'дин',
    RUB: '₽',
    RWF: 'RF',
    SAR: 'ر.س',
    // SBD: '$',
    SCR: '₨',
    SDG: 'ج.س.',
    SEK: 'kr',
    SGD: '$',
    SHP: '£',
    SLL: 'Le',
    SOS: 'Sh',
    SRD: '$',
    // SSP: '£',
    // STN: 'Db',
    SYP: 'ل.س',
    SZL: 'L',
    THB: '฿',
    TJS: 'ЅМ',
    TMT: 'm',
    TND: 'د.ت',
    TOP: 'T$',
    TRY: '₺',
    TTD: '$',
    TWD: 'NT$',
    TZS: 'TSh',
    UAH: '₴',
    UGX: 'UGX',
    USD: '$',
    UYU: '$',
    UZS: 'сўм',
    // VES: 'Bs.S',
    VND: '₫',
    VUV: 'Vt',
    WST: 'T',
    XAF: 'FCFA',
    XCD: '$',
    XDR: 'SDR',
    XOF: 'CFA',
    XPF: '₣',
    YER: '﷼',
    ZAR: 'R',
    ZMW: 'ZK',
    // ZWL: '$',
};

export const formatCurrency = (currencyCode) => {
    const symbol = currencySymbols[currencyCode] || currencyCode;
    return `${symbol}`;
};

